'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

import { showWarningToast } from '@/components/ui/sonner';
import { DONATION_PAYMENT_FAIL_MESSAGE } from '@/features/donations/consts';
import { DonationSuccessModal } from '@/features/donations/components/donation-success-modal';
import {
  clearPendingDonation,
  getPendingDonation,
} from '@/features/donations/utils/donation-pending-local-storage.utils';

export const DonationPaymentReturnHandler = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const wasDonated = searchParams.get('was_donated');
  const donationPaymentStatus = searchParams.get('donation_payment');

  const [isOpen, setIsOpen] = useState(false);
  const [authorName, setAuthorName] = useState('');

  useEffect(() => {
    if (donationPaymentStatus === 'fail') {
      showWarningToast(DONATION_PAYMENT_FAIL_MESSAGE);
      clearPendingDonation();

      const cleanedParams = new URLSearchParams(searchParams.toString());
      cleanedParams.delete('donation_payment');

      const nextUrl = cleanedParams.toString()
        ? `${pathname}?${cleanedParams.toString()}`
        : pathname;
      window.history.replaceState(null, '', nextUrl);

      return;
    }

    if (wasDonated !== 'true') {
      return;
    }

    const pending = getPendingDonation();
    clearPendingDonation();
    window.history.replaceState(null, '', pathname);

    if (!pending?.authorName) {
      return;
    }

    const frameId = requestAnimationFrame(() => {
      setAuthorName(pending.authorName);
      setIsOpen(true);
    });

    return () => cancelAnimationFrame(frameId);
  }, [donationPaymentStatus, pathname, searchParams, wasDonated]);

  return (
    <DonationSuccessModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      authorName={authorName}
    />
  );
};
